import { CustomExceptionResponse } from "@rms-types/exceptions";
import { AxiosError } from "axios";
import { enqueueSnackbar } from "notistack";

import { getErrorMessage } from "./errors";

const getPostSuccessMessage = (resourceName: string) => `Saved ${resourceName} Successfully`;
const getPostErrorMessage = (resourceName: string) => `Unable to save ${resourceName}`;

const getFetchSuccessMessage = (resourceName: string) => `Fetched ${resourceName} Successfully`;
const getFetchErrorMessage = (resourceName: string) => `Unable to get ${resourceName}`;

const getPatchSuccessMessage = (resourceName: string) => `Updated ${resourceName} Successfully`;
const getPatchErrorMessage = (resourceName: string) => `Unable to update ${resourceName}`;

const getDeleteSuccessMessage = (resourceName: string) => `Deleted ${resourceName} Successfully`;
const getDeleteErrorMessage = (resourceName: string) => `Unable to delete ${resourceName}`;

const enqueueSuccessSnackbar = (message: string) => enqueueSnackbar(message, { variant: "success" });
const enqueueErrorSnackbar = (message: string, error?: AxiosError<CustomExceptionResponse>) =>
  enqueueSnackbar(getErrorMessage(error, message), { variant: "error" });

export const getSnackbarMessages = (resourceName = "") => {
  return {
    triggerGenericSuccessMessage: () => enqueueSuccessSnackbar(`Saved successfully`),
    triggerGenericErrorMessage: () => enqueueErrorSnackbar(`Failed to save`),

    triggerPostSuccessMessage: () => enqueueSuccessSnackbar(getPostSuccessMessage(resourceName)),
    triggerPostErrorMessage: (error?: AxiosError<CustomExceptionResponse>) =>
      enqueueErrorSnackbar(getPostErrorMessage(resourceName), error),

    triggerFetchSuccessMessage: () => enqueueSuccessSnackbar(getFetchSuccessMessage(resourceName)),
    triggerFetchErrorMessage: (error?: AxiosError<CustomExceptionResponse>) =>
      enqueueErrorSnackbar(getFetchErrorMessage(resourceName), error),

    triggerPatchSuccessMessage: () => enqueueSuccessSnackbar(getPatchSuccessMessage(resourceName)),
    triggerPatchErrorMessage: (error?: AxiosError<CustomExceptionResponse>) =>
      enqueueErrorSnackbar(getPatchErrorMessage(resourceName), error),

    triggerDeleteSuccessMessage: () => enqueueSuccessSnackbar(getDeleteSuccessMessage(resourceName)),
    triggerDeleteErrorMessage: (error?: AxiosError<CustomExceptionResponse>) =>
      enqueueErrorSnackbar(getDeleteErrorMessage(resourceName), error),
  };
};
